"use client";
import { Link } from "@/components/CustomLink";
import { ROUTES } from "@/@core/constants/routes";
import { Button } from "@/components/ui/button";
import { usePlausible } from "next-plausible";
import { CLICK_QUOTE_EVENT_SECTIONS, PLAUSIBLE_GOAL_KEYS } from "@/@core/constants/plausible";
import { useClientTranslation } from "@/app/i18n/client";
import { cn } from "@/lib/utils";
import { useIsAskQuestionEnabled } from "@/hooks/useIsAskQuestionEnabled";

interface Props {
  buttonClassName?: string;
  fullWidth?: boolean;
}

export default function WorkerHeaderQuoteButton(props: Props) {
  const { buttonClassName, fullWidth = false } = props;
  const plausible = usePlausible();
  const { t } = useClientTranslation("tr", "site");
  const isAskQuestionEnabled = useIsAskQuestionEnabled();

  const sendPlausibleEvent = () => {
    plausible(PLAUSIBLE_GOAL_KEYS.CLICK_QUOTE_EVENT, {
      props: {
        section: CLICK_QUOTE_EVENT_SECTIONS.WORKERS_PAGE,
      },
    });
  };

  if (!isAskQuestionEnabled) return null;

  return (
    <Link
      className={cn(fullWidth ? "w-full" : "")}
      onClick={() => sendPlausibleEvent()}
      aria-label={`${t("quote-button-title")}`}
      href={ROUTES.CONTACT_WITH_VENUES}
    >
      <Button variant="gradient" className={cn(buttonClassName)}>
        {t("quote-button-title")}
      </Button>
    </Link>
  );
}
